import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import HomePage from '@/pages/HomePage';
import ParameterStore from '@/screens/AuditLogs/ParameterStore';
import ForgotPasswordPage from '@/screens/Auth/ForgotPassword';
import LoginPage from '@/screens/Auth/Login';
import OTPPage from '@/screens/Auth/OTP';
import SetPasswordPage from '@/screens/Auth/SetPassword';
import BlockedPaymentMethodList from '@/screens/Blocked/PaymentMethods';
import Disputes from '@/screens/Disputes';
import Fees from '@/screens/Fees';
import KYCDetails from '@/screens/KYC/Details';
import KycReceiptPage from '@/screens/KYC/Details/KycReceiptPage';
import KYCList from '@/screens/KYC/List';
import MerchantAffiliateProgram from '@/screens/Merchants/Affiliate';
import {BusinessDetailsScreen} from '@/screens/Merchants/Businesses/Details';
import BusinessRFILogsScreen from '@/screens/Merchants/Businesses/Details/BusinessRFITab/BusinessRFILogsScreen';
import BusinessesScreen from '@/screens/Merchants/Businesses/List';
import MerchantBusinessWebhookDeliveries from '@/screens/Merchants/Businesses/WebhookDeliveries';
import MerchantLogsScreen from '@/screens/Merchants/BusinessLogs';
import MerchantFeatureList from '@/screens/Merchants/Feature';
import MerchantFeeList from '@/screens/Merchants/Fee/index';
import BusinessInvitesScreen from '@/screens/Merchants/Invites';
import MerchantInvoiceList from '@/screens/Merchants/Invoices';
import MerchantKYBScreen from '@/screens/Merchants/Kyc/KybDetails';
import MerchantKYCScreen from '@/screens/Merchants/Kyc/KycDetails';
import MerchantKYCList from '@/screens/Merchants/Kyc/List/MerchantKYCList';
import MerchantLimitList from '@/screens/Merchants/Limit';
import LiveAccessScreen from '@/screens/Merchants/LiveAccess';
import BusinessLiveAccessLogsScreen from '@/screens/Merchants/LiveAccess/BusinessLiveAccessLogsScreen';
import MarketPlaceScreen from '@/screens/Merchants/Marketplace';
import PinResetRequestsScreen from '@/screens/Merchants/PinResetRequests';
import MerchantPoolAccountList from '@/screens/Merchants/PoolAccount';
import PricingNegotiationsScreen from '@/screens/Merchants/PricingNegotiations';
import BusinessRates from '@/screens/Merchants/Rates';
import MerchantSettlementAccountList from '@/screens/Merchants/SettlementAccounts';
import MerchantTransactionDetailsPage from '@/screens/Merchants/Transactions/Details/TransactionDetailsPage';
import MerchantTransactionList from '@/screens/Merchants/Transactions/List';
import MerchantBusinessTransactionList from '@/screens/Merchants/Transactions/List/Business';
import MerchantUserDetails from '@/screens/Merchants/Users/Details/index';
import MerchantUserList from '@/screens/Merchants/Users/List/index';
import MerchantAccountStatementPage from '@/screens/Merchants/Users/Statement';
import ProcessorBalanceScreen from '@/screens/Processor/Balance';
import ProcessorBanks from '@/screens/Processor/Banks';
import ProcessorCorridors from '@/screens/Processor/Corridors';
import ProcessorList from '@/screens/Processor/List';
import Metrics from '@/screens/Processor/Metrics';
import ProcessorResolvers from '@/screens/Processor/Resolvers';
import ProcessorTestTransactions from '@/screens/Processor/TestTransactions';
import AfriexTransactionProcessor from '@/screens/Processor/Transactions';
import TransactionDetail from '@/screens/Processor/Transactions/Detail';
import WebhookSimulatorScreen from '@/screens/Processor/WebhookSimulator';
import ProductUpdateCompose from '@/screens/ProductUpdates/Compose';
import ProductUpdatesList from '@/screens/ProductUpdates/List';
import NotificationPage from '@/screens/PushNotification/NotificationPage';
import RatesPage from '@/screens/Rates';
import TradeLogs from '@/screens/Rates/OTCTrades/TradeLogs';
import TierDetails from '@/screens/Rates/Promo/Details';
import ReferralList from '@/screens/Referral/List';
import ReferralTierDetails from '@/screens/Referral/Tier/Details';
import ReferralTierList from '@/screens/Referral/Tier/List';
import RewardDetails from '@/screens/Rewards/Card/Details';
import RewardCards from '@/screens/Rewards/List';
import AdminList from '@/screens/Settings/Admins/List';
import AppReleasesPage from '@/screens/Settings/AppReleases';
import BusinessCountryDetails from '@/screens/Settings/BusinessCountry/Details';
import ConfigPage from '@/screens/Settings/Config';
import CountryDetails from '@/screens/Settings/Country/Details';
import CurrencyDetails from '@/screens/Settings/Currency/Details';
import SubScriptionPlansPage from '@/screens/SubscriptionPlans';
import TransactionDetailsPage from '@/screens/Transaction/Details/TransactionDetailsPage';
import TransactionReceiptPage, {
  MerchantTransactionReceiptPage,
} from '@/screens/Transaction/Details/TransactionReceiptPage';
import TransactionList from '@/screens/Transaction/List';
import UserTransactionsPage from '@/screens/Transaction/List/User';
import RewardTransactionsPage from '@/screens/Transaction/Rewards';
import AttributionMetrics from '@/screens/User/Attribution/AttributionMetrics';
import UserDetails from '@/screens/User/Details'; //
import UserList from '@/screens/User/List';
import AccountStatementPage from '@/screens/User/Statement';
import UserLogsScreen from '@/screens/UserLogs';

// Re-exported from the leaf file so existing `from './routesConfig'` callers
// keep working; new callers should import `appPaths` from './appPaths' directly
// to avoid pulling in the router's full screen graph.
export {appPaths} from './appPaths';
import {appPaths} from './appPaths';

export const privateRoutesConfig = [
  {
    path: appPaths.home,
    Component: HomePage,
  },
  {
    path: appPaths.transactions,
    Component: TransactionList,
    permission: AfriexAdminPermission.TransactionRead,
  },
  {
    path: `${appPaths.transactions}/:transactionId`,
    Component: TransactionDetailsPage,
    permission: AfriexAdminPermission.TransactionRead,
  },
  {
    path: `${appPaths.transactions}/:transactionId/receipt`,
    Component: TransactionReceiptPage,
    permission: AfriexAdminPermission.TransactionRead,
  },
  {
    path: `${appPaths.transactions}/user/:userId`,
    Component: UserTransactionsPage,
    permission: AfriexAdminPermission.UserTransactionRead,
  },
  {
    path: `${appPaths.transactions}/user/:userId/receipt`,
    Component: TransactionReceiptPage,
    permission: AfriexAdminPermission.TransactionRead,
  },
  {
    path: `${appPaths.transactions}/user/:userId/statement`,
    Component: AccountStatementPage,
    permission: AfriexAdminPermission.UserTransactionRead,
  },
  {
    path: `${appPaths.transactions}/rewards/:userId`,
    Component: RewardTransactionsPage,
    permission: AfriexAdminPermission.TransactionRewardedRead,
  },
  {
    path: appPaths.subscriptionPlans,
    Component: SubScriptionPlansPage,
    permission: AfriexAdminPermission.SubscriptionPlanRead,
  },
  {
    path: appPaths.users,
    Component: UserList,
  },
  {
    path: `${appPaths.users}/metrics`,
    Component: AttributionMetrics,
  },
  {
    path: `${appPaths.users}/:userId`,
    Component: UserDetails,
  },
  {
    path: appPaths.kyc,
    Component: KYCList,
  },
  {
    path: `${appPaths.kyc}/:userId`,
    Component: KYCDetails,
  },
  {
    path: `${appPaths.kyc}/:userId/receipt`,
    Component: KycReceiptPage,
  },
  {
    path: appPaths.referral,
    Component: ReferralList,
  },
  {
    path: appPaths.merchantInvites,
    Component: BusinessInvitesScreen,
  },
  {
    path: appPaths.merchants,
    Component: BusinessesScreen,
  },
  {
    path: `${appPaths.merchants}/businesses`,
    Component: BusinessesScreen,
  },
  {
    path: `${appPaths.merchants}/live-access`,
    Component: LiveAccessScreen,
    permission: AfriexAdminPermission.BusinessLiveAccessRead,
  },
  {
    path: `${appPaths.merchants}/businesses/:businessId`,
    Component: BusinessDetailsScreen,
  },
  {
    path: `${appPaths.merchants}/businesses/:businessId/rfi/:rfiId/logs`,
    Component: BusinessRFILogsScreen,
    permission: AfriexAdminPermission.RFIRead,
  },
  {
    path: `${appPaths.merchants}/businesses/:businessId/live-access/:requestId/logs`,
    Component: BusinessLiveAccessLogsScreen,
    permission: AfriexAdminPermission.BusinessLiveAccessRead,
  },
  {
    path: `${appPaths.merchants}/business/:businessId/webhooks`,
    Component: MerchantBusinessWebhookDeliveries,
  },
  {
    path: `${appPaths.merchants}/transactions`,
    Component: MerchantTransactionList,
  },
  {
    path: `${appPaths.merchants}/transactions/:transactionId`,
    Component: MerchantTransactionDetailsPage,
  },
  {
    path: `${appPaths.merchants}/transactions/:transactionId/receipt`,
    Component: MerchantTransactionReceiptPage,
  },
  {
    path: `${appPaths.merchants}/transactions/business/:businessId`,
    Component: MerchantBusinessTransactionList,
  },
  {
    path: `${appPaths.merchants}/users`,
    Component: MerchantUserList,
  },
  {
    path: appPaths.merchantAffiliate,
    Component: MerchantAffiliateProgram,
    permission: AfriexAdminPermission.BusinessAffiliateRead,
  },
  {
    path: `${appPaths.merchants}/users/:userId`,
    Component: MerchantUserDetails,
  },
  {
    path: `${appPaths.merchants}/users/:userId/statement`,
    Component: MerchantAccountStatementPage,
  },
  {
    path: `${appPaths.merchants}/kyc`,
    Component: MerchantKYCList,
  },
  {
    path: `${appPaths.merchants}/kyc/:userId`,
    Component: MerchantKYCScreen,
  },
  {
    path: `${appPaths.merchants}/kyb/:businessId`,
    Component: MerchantKYBScreen,
  },
  {
    path: `${appPaths.merchants}/fees`,
    Component: MerchantFeeList,
  },
  {
    path: `${appPaths.merchants}/pricing-negotiations`,
    Component: PricingNegotiationsScreen,
    permission: AfriexAdminPermission.BusinessFeeNegotiationRead,
  },
  {
    path: `${appPaths.merchants}/invoices`,
    Component: MerchantInvoiceList,
  },
  {
    path: `${appPaths.merchants}/settlement-accounts`,
    Component: MerchantSettlementAccountList,
  },
  {
    path: `${appPaths.merchants}/rates`,
    Component: BusinessRates,
  },

  {
    path: `${appPaths.merchants}/features`,
    Component: MerchantFeatureList,
  },
  {
    path: `${appPaths.merchants}/limits`,
    Component: MerchantLimitList,
  },
  {
    path: `${appPaths.merchants}/pool-accounts`,
    Component: MerchantPoolAccountList,
  },
  {
    path: `${appPaths.merchants}/pin-reset-requests`,
    Component: PinResetRequestsScreen,
  },
  {
    path: appPaths.merchantMarketPlace,
    Component: MarketPlaceScreen,
    permission: AfriexAdminPermission.MarketPlaceRead,
  },
  {
    path: `${appPaths.merchants}/logs`,
    Component: MerchantLogsScreen,
  },
  {
    path: `${appPaths.logs}/:userId`,
    Component: UserLogsScreen,
  },
  {
    path: appPaths.referral + '/list',
    Component: ReferralList,
  },
  {
    path: appPaths.referral + '/tiers',
    Component: ReferralTierList,
  },
  {
    path: `${appPaths.referral}/tiers/:tierId`,
    Component: ReferralTierDetails,
  },
  {
    path: appPaths.notification,
    Component: NotificationPage,
    permission: AfriexAdminPermission.PushNotificationSend,
  },
  {
    path: appPaths.disputes,
    Component: Disputes,
    permission: AfriexAdminPermission.DisputeRead,
  },
  {
    path: appPaths.rates,
    Component: RatesPage,
  },
  {
    path: `${appPaths.rates}/tiers/:tierId`,
    Component: TierDetails,
  },
  {
    path: `${appPaths.rates}/trade-logs`,
    Component: TradeLogs,
  },
  {
    path: appPaths.fees,
    Component: Fees,
    permission: AfriexAdminPermission.TransactionFeeRead,
  },
  {
    path: appPaths.processors,
    Component: ProcessorList,
  },
  {
    path: appPaths.processors + '/corridors',
    Component: ProcessorCorridors,
  },
  {
    path: appPaths.processors + '/resolvers',
    Component: ProcessorResolvers,
  },
  {
    path: appPaths.processors + '/banks',
    Component: ProcessorBanks,
  },
  {
    path: appPaths.processors + '/metrics',
    Component: Metrics,
  },
  {
    path: `${appPaths.processors}/transactions`,
    Component: AfriexTransactionProcessor,
  },
  {
    path: `${appPaths.processors}/transactions/:transactionId`,
    Component: TransactionDetail,
  },
  {
    path: `${appPaths.processors}/test-transactions`,
    Component: ProcessorTestTransactions,
  },
  {
    path: `${appPaths.processors}/balance`,
    Component: ProcessorBalanceScreen,
  },
  {
    path: `${appPaths.processors}/webhooks-simulator`,
    Component: WebhookSimulatorScreen,
  },
  {
    path: appPaths.blockedPaymentMethods,
    Component: BlockedPaymentMethodList,
    permission: AfriexAdminPermission.BlockedPaymentMethodRead,
  },
  {
    path: appPaths.rewards,
    Component: RewardCards,
    permission: AfriexAdminPermission.RewardRead,
  },
  {
    path: appPaths.cards,
    Component: RewardCards,
    permission: AfriexAdminPermission.RewardRead,
  },
  {
    path: `${appPaths.rewards}/:id`,
    Component: RewardDetails,
    permission: AfriexAdminPermission.RewardRead,
  },
  {
    path: appPaths.productUpdates,
    Component: ProductUpdatesList,
    permission: AfriexAdminPermission.BusinessUpdateRead,
  },
  {
    path: `${appPaths.productUpdates}/new`,
    Component: ProductUpdateCompose,
    permission: AfriexAdminPermission.BusinessUpdateManage,
  },
  {
    path: `${appPaths.productUpdates}/:updateId`,
    Component: ProductUpdateCompose,
    permission: AfriexAdminPermission.BusinessUpdateRead,
  },
  {
    path: appPaths.settings,
    Component: AdminList,
  },
  {
    path: appPaths.admins,
    Component: AdminList,
  },
  {
    path: appPaths.config,
    Component: ConfigPage,
  },
  {
    path: `${appPaths.config}/country/:countryCode`,
    Component: CountryDetails,
  },
  {
    path: `${appPaths.config}/business-country/:countryCode`,
    Component: BusinessCountryDetails,
  },
  {
    path: `${appPaths.config}/currencies/:currencyCode`,
    Component: CurrencyDetails,
  },
  {
    path: appPaths.parameterStore,
    Component: ParameterStore,
  },
  {
    path: appPaths.appReleases,
    Component: AppReleasesPage,
  },
];

export const publicRoutesConfig = [
  {
    path: appPaths.login,
    Component: LoginPage,
    roles: [],
  },

  {
    path: appPaths.verifyOtp,
    Component: OTPPage,
    roles: [],
  },
  {
    path: appPaths.forgotPassword,
    Component: ForgotPasswordPage,
    roles: [],
  },
  {
    path: appPaths.setPassword,
    Component: SetPasswordPage,
    roles: [],
  },
];
